
export default {
  need: '#00cf19',
  responsibility: '#843cfd',
  person: '#ef9322',
  info: '#666666',
  dependency: '#CE003D',
  guide: '#666666',
  realizer: '#843cfd',
};
